export default "__VITE_ASSET__BSarvE87__"